import { inject } from 'vue';

export const useSandBox = () => {
    const isSandbox = inject('sandbox', false);

    return isSandbox;
};
